import { Files } from '@constants'

export const formatFileType = (type) => {
  switch (true) {
    case Files.SUPPORTED_FILE_TYPES.AUDIOS.includes(type):
      return { value: 'Audio', icon: 'sound' }
    case Files.SUPPORTED_FILE_TYPES.IMAGES.includes(type):
      return { value: 'Image', icon: 'photo' }
    case Files.SUPPORTED_FILE_TYPES.CODE.includes(type):
      return { value: 'Code', icon: 'code closed' }
    case Files.SUPPORTED_FILE_TYPES.NOTE.includes(type):
      return { value: 'Note', icon: 'text' }
    case Files.SUPPORTED_FILE_TYPES.SKETCH.includes(type):
      return { value: 'Sketch', icon: 'pencil fill' }
    case Files.SUPPORTED_FILE_TYPES.PDF.includes(type):
      return { value: 'PDF', icon: 'pdf' }
    case Files.SUPPORTED_FILE_TYPES.VIDEOS.includes(type):
      return { value: 'Video', icon: 'video' }
    case Files.SUPPORTED_FILE_TYPES.LINK.includes(type):
      return { value: 'Link', icon: 'url on' }
    default:
      return { value: 'File', icon: 'document outline' }
  }
}
